(ns global.endor.checkout.ui.components.button
  (:require [global.endor.checkout.ui.style.colors :as colors]
            [global.endor.checkout.ui.style.elements :as style]
            [global.endor.checkout.ui.components.basics :as ui]
            [uix.core :refer [$ defui]]))

(defn inner-spacing [size]
  {:padding-left   (get-in style/padding
                           [:left-right
                            (case size
                              (:large :medium) :large
                              :small :medium)])
   :padding-right  (get-in style/padding
                           [:left-right
                            (case size
                              (:large :medium) :large
                              :small :medium)])

   :padding-top    (get-in style/padding
                           [:top-bottom
                            (case size
                              :large :large
                              (:medium :small) :medium)])
   :padding-bottom (get-in style/padding
                           [:top-bottom
                            (case size
                              :large :large
                              (:medium :small) :medium)])
   :gap (get-in style/gap
                [:left-right
                 :medium])})

(defn border-style [level]
  (case level
    (:primary :secondary) {:border-radius (style/radius :small)
                           :border-width 1
                           :border-color (get-in colors/button [level :stroke])}
    (:caution :tertiary) {}))

(defui button [{:keys [level size text description icon on-press style]}]
  (let [colors (colors/button level)]
    ($ :button
       {:style (merge {:display "flex"
                       :flex-direction "row"
                       :justify-content (if (or icon description) "space-between" "center")
                       :align-items "center"
                       :background-color (colors :bg)
                       :border-radius 0
                       :text-decoration "none"
                       :border-width 0}
                      (inner-spacing size)
                      (border-style level)
                      style)
        :on-click on-press}
       (when text
         ($ ui/text
            {:style [(style/font (case size (:large :medium) :h4 :small :body))
                     {:color (colors :text)}]}
            text))
       (when description
         ($ ui/text
            {:style [(style/font (case size (:large :medium) :h4 :small :body))
                     {:color (colors :text)}]}
            description))
       (when icon
         ($ icon
            {:size (case size (:large :medium) 20 :small 16)
             :color (colors :icon)})))))

(defui icon-button
  [{:keys [icon on-press size color style background]}]
  ($ :div
     {:style (merge {:display "flex"
                     :border-radius (style/radius :small)
                     :padding-left (get-in style/padding
                                           [:left-right
                                            (case size :large :medium (:medium :small) :small)])
                     :padding-right (get-in style/padding
                                            [:left-right
                                             (case size :large :medium (:medium :small) :small)])
                     :padding-top (get-in style/padding
                                          [:top-bottom
                                           (case size :large :medium (:medium :small) :small)])
                     :padding-bottom (get-in style/padding
                                             [:top-bottom
                                              (case size :large :medium (:medium :small) :small)])}
                    (when background
                      {:background-color (get-in colors/background-sub
                                                 [:secondary :10-percent])})
                    style)
      :on-click on-press}
     (when icon
       ($ icon
          {:size (case size :large 24 :medium 20 :small 16)
           :color (or color (colors/text :primary))}))))
